
    import Vue from "vue";

    const END_POINT = "/studentRequirementSubmission";

    const getStudentRequirementSubmission = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllStudentRequirementSubmissions = data => Vue.axios.get(END_POINT, {params: data});

    const createStudentRequirementSubmission = studentRequirementSubmission => Vue.axios.post(END_POINT,  studentRequirementSubmission );

    const createAllStudentRequirementSubmissions = StudentRequirementSubmissions => Vue.axios.post(END_POINT + "/all",  StudentRequirementSubmissions );

    const updateStudentRequirementSubmission = studentRequirementSubmission => Vue.axios.put(END_POINT  + "/" + studentRequirementSubmission.id,  studentRequirementSubmission );

    const deleteStudentRequirementSubmission = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getStudentRequirementSubmission,
      getAllStudentRequirementSubmissions,
      createStudentRequirementSubmission,
      createAllStudentRequirementSubmissions,
      updateStudentRequirementSubmission,
      deleteStudentRequirementSubmission
    };
    